var _excluded = ["children", "disabled", "readOnly", "style", "className", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import AlloyCheckbox from '@adsk/alloy-react-checkbox';
import { getMixin } from '@adsk/nirvana-theme';
import { Wrapper, Toggle, Label } from './styles';

/**
 * Checkbox
 *
 * Composed Alloy component - `@adsk/alloy-react-checkbox`
 * Add extra support
 *  1. Use `children` to render with label
 *  2. Use margin shorthands `mx`, `my`, `mb`, `mr`, `ml`, `mt`
 */
var Checkbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    style = _ref.style,
    className = _ref.className,
    onChange = _ref.onChange,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _getMixin = getMixin(rest),
    margins = _getMixin.margins,
    others = _getMixin.others;
  var handleChange = function handleChange(value, event) {
    event && event.stopPropagation();
    onChange && onChange(value, event);
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    "data-testid": "checkbox",
    style: style,
    className: className
  }, margins), /*#__PURE__*/React.createElement(Toggle, _extends({
    "data-testid": "checkbox-input",
    ref: ref,
    disabled: disabled,
    readOnly: readOnly,
    onChange: handleChange
  }, others)), children && /*#__PURE__*/React.createElement(Label, {
    "data-testid": "checkbox-label",
    disabled: disabled,
    readOnly: readOnly
  }, children));
});
Checkbox.displayName = 'Checkbox';

// exposed for styling
Checkbox.Toggle = Toggle;
Checkbox.Label = Label;
Checkbox.INDETERMINATE = AlloyCheckbox.INDETERMINATE;
Checkbox.propTypes = _objectSpread({
  children: PropTypes.node
}, AlloyCheckbox.propTypes);
export default Checkbox;
//# sourceMappingURL=index.js.map